export default __webpack_public_path__ + "static/media/13.a4d0db25.png";